import { createAction } from "@ngrx/store";

export namespace AamsGameDataAction {
	const ACTION_PREFIX = "[AAMS Game Data]";

	export const gameReady = createAction(`${ACTION_PREFIX} Game Ready`, (data: any) => ({ data }));

	export const setIsSessionDisplayed = createAction(
		`${ACTION_PREFIX} Set Is Session Displayed`,
		(isSessionDisplayed: boolean) => ({ isSessionDisplayed })
	);

	export const gameSessionUpdated = createAction(`${ACTION_PREFIX} Game Session Updated`, (data?: any) => ({ data }));

	export const gameRemove = createAction(`${ACTION_PREFIX} Game Remove`);

	export const getAdditionalParameters = createAction(
		`${ACTION_PREFIX} Get Additional Parameters`,
		(data: string) => ({ data })
	);
}
